export default __webpack_public_path__ + "static/media/alur-box-4.79981df1.png";